import { render, staticRenderFns } from "./promise.vue?vue&type=template&id=211d28ee&scoped=true"
import script from "./promise.vue?vue&type=script&lang=js"
export * from "./promise.vue?vue&type=script&lang=js"
import style0 from "./promise.vue?vue&type=style&index=0&id=211d28ee&prod&lang=scss&scoped=true"
import style1 from "./promise.vue?vue&type=style&index=1&id=211d28ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211d28ee",
  null
  
)

export default component.exports